import { render, staticRenderFns } from "./Perfume.vue?vue&type=template&id=46f649a3&scoped=true&"
import script from "./Perfume.vue?vue&type=script&lang=js&"
export * from "./Perfume.vue?vue&type=script&lang=js&"
import style0 from "./Perfume.vue?vue&type=style&index=0&id=46f649a3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f649a3",
  null
  
)

export default component.exports